module.exports = __webpack_public_path__ + "static/area-with-negative-values-8ebcc2e8f5eb5d397429a81e58fa92c9.png";